"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const ShopCheckoutSummary_1 = __importDefault(require("./ShopCheckoutSummary"));
const ShopCheckoutLayout = ({ children, className, showSidebarMobile, title, submitElement, summaryElement, loading, }) => (react_1.default.createElement("section", { className: (0, classnames_1.default)('znd-shop-checkout-page__wrapper', className) },
    react_1.default.createElement("header", { className: "znd-shop-checkout-page__header" },
        react_1.default.createElement("h1", { className: "znd-shop-checkout-page__title" }, title)),
    react_1.default.createElement("div", { className: "znd-shop-checkout-page__content" },
        react_1.default.createElement("section", { className: "znd-shop-checkout-page__main" }, children),
        react_1.default.createElement("aside", { className: (0, classnames_1.default)('znd-shop-checkout-page__sidebar', {
                'znd-shop-checkout-page__sidebar--always': showSidebarMobile,
            }) }, summaryElement === undefined ? react_1.default.createElement(ShopCheckoutSummary_1.default, { loading: loading }) : summaryElement),
        submitElement ? react_1.default.createElement("footer", { className: "znd-shop-checkout-page__footer" }, submitElement) : null,
        react_1.default.createElement("div", { className: "znd-shop-checkout-page__empty" }))));
exports.default = ShopCheckoutLayout;
